<template>
  <div>
    <p class="font-weight-bold mt-6 px-8">
      Tågvändingar
    </p>

    <TrafficMessageRow :items="list" />
  </div>
</template>

<script>
import { get } from 'vuex-pathify'
import TrafficMessageRow from './TrafficMessageRow'
import diffFactory from '@/helpers/diffFactory'

export default {
  name: 'TrafficMessageTurnaroundTrainsText',

  components: {
    TrafficMessageRow
  },

  computed: {
    turnarounds: get('turnaround/data'),
    model: get('trafficMessage/model'),
    stops: get('event/stops'),

    list() {
      const findLocationName = signature => {
        const location = this.stops.find(
          x => x.short_name === signature.toUpperCase()
        )
        return location ? location.stop_name : signature.toUpperCase()
      }

      const turnarounds = diffFactory(
        this.model.turnarounds,
        x =>
          `Tågvändning, ${x.train_number_from} - ${
            x.train_number_to
          }, ${findLocationName(x.location)}`,
        this.turnarounds
      )

      return turnarounds
    }
  }
}
</script>
